import React, { FC, useEffect } from "react";
import clsx from "clsx";

import { IActionLessons } from "../../../../state";
import { ReactComponent as CheckIconCircleOff } from "../../../../assets/images/ActionList/check_icon_circle_off.svg";
import { ReactComponent as CheckIconCircleOn } from "../../../../assets/images/ActionList/check_icon_circle_on.svg";

import styles from "./ActionAnswerForm.module.scss";

export type Props = {
  lesson: IActionLessons;
  handleSubmitRealization: (
    lesson_id: number,
    content: string,
    realization_id: number | null,
  ) => void;
  calling: boolean;
  isRetrospectiveAnswered: (lesson: IActionLessons) => boolean;
};

const ActionAnswerForm: FC<Props> = ({
  lesson,
  handleSubmitRealization,
  calling,
  isRetrospectiveAnswered,
}) => {
  const [content, setContent] = React.useState<string>("");

  useEffect(() => {
    if (lesson.reflection_realization_reference !== null) {
      setContent(lesson.reflection_realization_reference.content);
    }
  }, [lesson.reflection_realization_reference]);

  const isReflected = lesson?.reflection_realization_reference !== null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.lesson}>
        {isReflected ? (
          <CheckIconCircleOn className={styles.checkIcon} />
        ) : (
          <CheckIconCircleOff className={styles.checkIcon} />
        )}
        <span className={styles.name}>{lesson.name}</span>
        <span className={styles.title}>{lesson.title}</span>
      </div>
      {isRetrospectiveAnswered(lesson) ? (
        <>
          <div className={styles.retrospective}>
            <p className={styles.title}>振り返りWORKに入力した内容</p>
            <div className={styles.list}>
              <div className={styles.item}>
                <p className={styles.heading}>
                  <span className={styles.number}>01</span>授業で学んだこと
                </p>
                <p className={styles.text}>
                  {lesson?.answer?.contents?.[0]?.content}
                </p>
              </div>
              <div className={styles.item}>
                <p className={styles.heading}>
                  <span className={styles.number}>02</span>
                  学びから行動するとしたら？
                </p>
                <p className={styles.text}>
                  {lesson?.answer?.contents?.[1]?.content}
                </p>
              </div>
            </div>
          </div>
          <div className={styles.reflection}>
            <p className={styles.heading}>
              <span className={styles.number}>03</span>行動から生まれた気づき
            </p>
            <textarea
              id={`reflection-${lesson.id}`}
              name={`reflection-${lesson.id}`}
              className={styles.textarea}
              placeholder="具体的にどんな行動をしたのか、それによって気づいたことや思ったことなどを入力しましょう。"
              value={content}
              onChange={e => setContent(e.target.value)}
            />
            <button
              className={clsx(
                styles.saveButton,
                isReflected && styles.isReflected,
              )}
              onClick={() =>
                handleSubmitRealization(
                  lesson.id,
                  content,
                  lesson.reflection_realization_reference?.realization_id ||
                    null,
                )
              }
              disabled={!content.trim() || calling}
            >
              {isReflected ? "修正を保存する" : "保存する"}
            </button>
          </div>
        </>
      ) : (
        <p className={styles.note}>まだ振り返りWORKを入力していません。</p>
      )}
    </div>
  );
};

export default ActionAnswerForm;
